import script from "./consortiumListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./consortiumListModal.vue?vue&type=script&setup=true&lang=js"

import "./consortiumListModal.vue?vue&type=style&index=0&id=443ca4e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-443ca4e8"]])

export default __exports__